export default "/images/b941264d39d37cd53725b959bb4b6f23.avif";